import { useTar } from '@/modules/i18n/useTar'
import { isPrerenderedPath, swapLangInPath } from '@/modules/seo/prerenderedPaths'
import { isSupportedLanguage } from '@/modules/i18n/supportedLanguages'

export function useLocalizedHref(canonicalPath: string): string {
  const { language } = useTar()
  const lang = isSupportedLanguage(language) ? language : 'en'
  if (!isPrerenderedPath(canonicalPath)) return canonicalPath
  return swapLangInPath(canonicalPath, lang)
}
